import { render } from "./DupliquerProduitPage.vue?vue&type=template&id=049b7e37&ts=true"
import script from "./DupliquerProduitPage.vue?vue&type=script&lang=ts"
export * from "./DupliquerProduitPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__